import { Epic, ofType } from 'redux-observable';
import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { actions } from '.';
import { addErrorNotice, catchWithAuthErrors } from '../../Helpers/rxjsHelpers';
import { actions as worksheetEditorActions } from '../WorksheetEditor';
import { callApiGetPrototypeReadingsForTimeSequence } from './apiCalls';
import { HydrometerReadingModel } from './types';

/**
 * Epic that handles the "Populate Readings" button for the hydrometer worksheet.
 */
export const createReadingsForTimeSequence: Epic = (action$, state$) =>
  action$.pipe(
    ofType(actions.createReadingsForTimeSequence.toString()),
    mergeMap(() =>
      callApiGetPrototypeReadingsForTimeSequence(
        state$.value.worksheetEditor.worksheetId,
        state$.value.worksheetEditor.syncModel.data.HydrometerPortion.Measurements.TimeSequence.Id
      ).pipe(
        mergeMap(({ Readings: prototypeReadings }: { Readings: HydrometerReadingModel[] }) =>
          of(
            worksheetEditorActions.setValue({
              name: `data.HydrometerPortion.Measurements.Readings`,
              value: prototypeReadings,
              sync: true,
            }),
            actions.createReadingsForTimeSequenceResolve()
          )
        ),
        catchWithAuthErrors((err: any) =>
          of(actions.createReadingsForTimeSequenceReject(), addErrorNotice('Failed to create readings.', err))
        )
      )
    )
  );
